import React, { useState } from 'react'
import { Card } from 'react-bootstrap'
import CustomPagination from '../../components/CustomPagination'

export default function Invoices() {
  const invoiceData = [
    { id: 'INV-2024-001', date: 'Oct 25, 2024', amount: '$39.00', status: 'Paid' },
    { id: 'INV-2024-002', date: 'Sep 25, 2024', amount: '$39.00', status: 'Paid' },
    { id: 'INV-2024-003', date: 'Aug 25, 2024', amount: '$39.00', status: 'Paid' },
    { id: 'INV-2024-004', date: 'Jul 25, 2024', amount: '$39.00', status: 'Paid' },
  ]

  const [currentPage, setCurrentPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(2)

  const indexOfLast = currentPage * rowsPerPage
  const indexOfFirst = indexOfLast - rowsPerPage
  const currentInvoices = invoiceData.slice(indexOfFirst, indexOfLast)

  const total = invoiceData.length

  const handlePageChange = page => {
    setCurrentPage(page)
  }

  const handlePerPageChange = (newPerPage, page) => {
    setRowsPerPage(newPerPage)
    setCurrentPage(page)
  }

  return (
    <div className='subscription_management'>
      <div className='mt-4'>
        <h2 className='fw-bold h4 mb-4'>Invoice History</h2>
        <Card>
          <Card.Body className='p-0'>
            <CustomPagination
              isFetching={false}
              data={currentInvoices}
              total={total}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handlePerPageChange}
              paginationDefaultPage={currentPage}
              columns={[
                { name: 'Invoice ID', selector: row => row.id, sortable: true },
                { name: 'Date', selector: row => row.date, sortable: true },
                { name: 'Amount', selector: row => row.amount, sortable: true },
                {
                  name: 'Status',
                  selector: row => (
                    <span className='badge rounded-pill bg-success px-3 py-2'>{row.status}</span>
                  ),
                  sortable: true,
                },
                {
                  name: 'Actions',
                  cell: row => (
                    <a
                      href='#'
                      style={{
                        color: 'orange',
                        textDecoration: 'underline',
                        fontWeight: '500',
                      }}
                    >
                      View PDF
                    </a>
                  ),
                  ignoreRowClick: true,
                  allowOverflow: true,
                  button: true,
                },
              ]}
            />
          </Card.Body>
        </Card>
      </div>
    </div>
  )
}
